// Generated by bjt-data-sync script
// Do not edit manually

// Import the data from the JSON file
import dynamicConsumableOptionsData from './data/consumableFilterOptions.data.json';

// Remove the incorrect import from central types
// import { ConsumableFilterOptions, FilterOption, ModelFilterOption } from '../../types/consumables'; 

// Restore local definitions as they are needed here
export interface FilterOption {
  id: string;
  name: string;
  name_en?: string;
  image_url?: string;
}

export interface ModelFilterOption extends FilterOption {
  // ... comment remains ...
}

export interface ConsumableFilterOptions_Local {
  shapes: FilterOption[];
  materials: FilterOption[];
  models: ModelFilterOption[];
  thicknesses: FilterOption[];
  weights: FilterOption[];
  widths: FilterOption[];
  lengths: FilterOption[];
  modelExplodedViews: { [key: string]: string | null };
}

// Assign the imported data to the typed constant
// Use type assertion to ensure compatibility
export const dynamicConsumableOptions: ConsumableFilterOptions_Local = dynamicConsumableOptionsData as ConsumableFilterOptions_Local;

console.log('🔍 [FilterOptions 全部]', dynamicConsumableOptions);
if (dynamicConsumableOptions) {
  console.log('🔍 [FilterOptions] keys:', Object.keys(dynamicConsumableOptions));
  console.log('🔍 [FilterOptions] thicknesses:', dynamicConsumableOptions.thicknesses);
  console.log('🔍 [FilterOptions] widths:', dynamicConsumableOptions.widths);
  console.log('🔍 [FilterOptions] lengths:', dynamicConsumableOptions.lengths);
}
